import { useEffect } from 'react';
import '@/App.css';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
  useParams,
} from 'react-router-dom';
import { LanguageProvider, SUPPORTED_LANGS, useI18n } from '@/context/LanguageContext';
import ScrollToTop from '@/components/ScrollToTop';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import CookieBanner from '@/components/CookieBanner';
import { applyStoredConsent } from '@/lib/consent';
import Home from '@/pages/Home';
import Privacy from '@/pages/Privacy';
import CookiePolicy from '@/pages/CookiePolicy';
import Terms from '@/pages/Terms';
import ThankYou from '@/pages/ThankYou';

function Meta() {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.title = t('meta.title');
    document.documentElement.lang = lang === 'ar' ? 'es-AR' : 'en';
    let desc = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement('meta');
      desc.setAttribute('name', 'description');
      document.head.appendChild(desc);
    }
    desc.setAttribute('content', t('meta.description'));
  }, [t, lang]);
  return null;
}

function LangLayout() {
  const { lang } = useParams();
  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/ar" replace />;
  }
  return (
    <LanguageProvider lang={lang}>
      <Meta />
      <div className="inv-app flex min-h-screen flex-col bg-background">
        <Header />
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <CookieBanner />
      </div>
    </LanguageProvider>
  );
}

function App() {
  useEffect(() => {
    // Re-apply a previously saved consent choice on load (Consent Mode v2).
    applyStoredConsent();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/ar" replace />} />
        <Route path="/thank_you" element={<ThankYou />} />
        <Route path="/:lang" element={<LangLayout />}>
          <Route index element={<Home />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="cookies" element={<CookiePolicy />} />
          <Route path="terms" element={<Terms />} />
        </Route>
        <Route path="*" element={<Navigate to="/ar" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
